<template>
   <v-row no-gutters>
      <v-col cols="7">
        <div outlined tile class="text-body-2 text-right"> Monto Bruto </div>
      </v-col>
      <v-col cols="5">
        <div outlined tile class="text-body-2 text-right"> {{data.MontoBruto}} </div>
      </v-col>
      <v-col cols="7">
        <div outlined tile class="text-body-2 text-right"> Descuento </div>
      </v-col>
      <v-col cols="5">
        <div outlined tile class="text-body-2  text-right"> {{data.MontoDescuento}} </div>
      </v-col>
      <v-col cols="7">
        <div outlined tile class="text-body-2 text-right"> Monto Neto </div>
      </v-col>
      <v-col cols="5">
        <div outlined tile class="text-body-2 text-right"> {{data.MontoNeto}} </div>
      </v-col>
       <v-col cols="7">
        <div outlined tile class="text-body-2 text-right"> Monto Exento </div>
      </v-col>
      <v-col cols="5">
        <div outlined tile class="text-body-2 text-right"> {{data.MontoExento}} </div>
      </v-col>
       <v-col cols="7">
        <div outlined tile class="text-body-2 text-right"> Monto IVA </div>
      </v-col>
      <v-col cols="5">
        <div outlined tile class="text-body-2 text-right"> {{data.MontoIva}} </div>
      </v-col>
       <v-col cols="7">
        <div outlined tile class="text-body-2 text-right"> Monto Total </div>
      </v-col>
      <v-col cols="5">
        <div outlined tile class="text-body-2 text-right font-weight-bold"> {{data.MontoTotal}} </div>
      </v-col>
    </v-row>
</template>

<script>
export default {
props:{
    data: Object
}
}
</script>